/*
 * Onddoka お気に入り（♡）＋ コレクション切り替え時の絞り込み引き継ぎ ＋ SP のタイプ・カラーチップ
 * - 保存先：localStorage（キー onddoka_favorites_v1 / 商品ハンドルの配列・新しい順）
 * - ♡ボタン：snippets/onddoka-fav-button.liquid（[data-onddoka-fav="handle"]）
 * - 件数表示：[data-onddoka-fav-count]（ヘッダー）
 * - 一覧ページ：sections/onddoka-favorites.liquid（[data-onddoka-fav-page]）
 */
(function () {
  if (window.OnddokaFavorites) return;

  var KEY = 'onddoka_favorites_v1';
  /* ♡ の追加・解除の記録先（Onddoka顧客管理アプリ GAS・FavoriteLog.gs → DATA_SS「L_お気に入りログ」）。個人は特定しない */
  var LOG_URL = 'https://script.google.com/macros/s/AKfycbxcSOfvqH-kRg7J_wfVEo2ItwmPctrJYFO5qmHsBAwsduMyFmBLcfFQwgEzhVhSgpMR6A/exec';
  var MAX = 100;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {}
  }

  function has(handle) {
    return read().indexOf(handle) > -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1);
    else list.unshift(handle);
    write(list);
    return i === -1;
  }

  function remove(handle) {
    write(read().filter(function (h) { return h !== handle; }));
  }

  /* ---------- 計測：施策の効果を数字で見直すためのイベント記録（2026-10-18） ----------
   * 送信先：Onddoka顧客管理アプリ GAS（action=log_event → DATA_SS「L_UIイベントログ」）＋ Microsoft Clarity のカスタムイベント
   * 個人は特定しない。visitor_id はこのブラウザ用のランダムな番号（同じ人が何日かけて決めたか等を見るため）
   * イベント一覧と見直し方：03.Onddoka/Marketing/Notes/施策検証_首輪コレクション改修_2026-10.md */
  var VID_KEY = 'onddoka_vid';
  function visitorId() {
    try {
      var v = localStorage.getItem(VID_KEY);
      if (!v) {
        v = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem(VID_KEY, v);
      }
      return v;
    } catch (e) {
      return '';
    }
  }
  function pagePath() {
    try { return decodeURIComponent(window.location.pathname); } catch (e) { return window.location.pathname; }
  }
  function send(payload) {
    try {
      var body = JSON.stringify(payload);
      var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
      if (!(navigator.sendBeacon && navigator.sendBeacon(LOG_URL, blob))) {
        fetch(LOG_URL, { method: 'POST', mode: 'no-cors', keepalive: true, body: body });
      }
    } catch (e) {}
  }
  function track(name, value) {
    if (window.Shopify && window.Shopify.designMode) return; /* テーマエディタ内は記録しない */
    send({
      action: 'log_event',
      event: name,
      value: value == null ? '' : String(value).slice(0, 200),
      page: pagePath(),
      device: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'sp' : 'pc',
      locale: document.documentElement.lang || '',
      visitor_id: visitorId()
    });
    try { if (window.clarity) window.clarity('event', 'onddoka_' + name); } catch (e) {}
  }

  function logFavorite(handle, action, source, title) {
    try {
      var body = JSON.stringify({
        action: 'log_favorite',
        handle: handle,
        fav_action: action,
        source: source,
        title: title || '',
        locale: document.documentElement.lang || '',
        page: (function () { try { return decodeURIComponent(window.location.pathname); } catch (e) { return window.location.pathname; } })(),
        /* ログイン中の会員のみ Shopify 顧客ID（数字）。プライバシーポリシー第3条（2026-10-18 改定）に基づく */
        customer_id: window.OnddokaCustomerId ? String(window.OnddokaCustomerId) : '',
        visitor_id: visitorId()
      });
      try { if (window.clarity) window.clarity('event', 'onddoka_fav_' + action); } catch (e) {}
      var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
      if (!(navigator.sendBeacon && navigator.sendBeacon(LOG_URL, blob))) {
        fetch(LOG_URL, { method: 'POST', mode: 'no-cors', keepalive: true, body: body });
      }
    } catch (e) {}
  }

  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-onddoka-fav]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-onddoka-fav')) > -1;
      var label = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
      if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
      btn.classList.toggle('is-active', on);
      var text = btn.querySelector('[data-fav-text]');
      if (text && text.textContent !== label) text.textContent = label;
    });
    document.querySelectorAll('[data-onddoka-fav-count]').forEach(function (el) {
      var n = String(list.length);
      if (el.textContent !== n) el.textContent = n;
      el.hidden = list.length === 0;
    });
  }

  /* ---------- ♡ボタン ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-onddoka-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-onddoka-fav');
    var added = toggle(handle);
    syncButtons();
    var source = btn.classList.contains('onddoka-fav--icon') ? 'icon' : btn.classList.contains('onddoka-fav--product') ? 'product' : 'card';
    logFavorite(handle, added ? 'add' : 'remove', source, btn.getAttribute('data-title'));
    if (added) {
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
    }
  });

  /* ---------- 商品ページのシェアボタン（snippets/onddoka-share-button.liquid） ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-onddoka-share]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-share-url');
    var title = btn.getAttribute('data-share-title');
    track('share_click', navigator.share ? 'native' : 'copy');
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    var toast = btn.querySelector('[data-share-toast]');
    function done() {
      if (!toast) return;
      toast.textContent = btn.getAttribute('data-label-copied');
      toast.hidden = false;
      clearTimeout(btn._t);
      btn._t = setTimeout(function () { toast.hidden = true; }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
    } else {
      window.prompt('', url);
    }
  });

  /* ---------- コレクション説明文の CATEGORY リンク（形の切り替え）：絞り込み・並び順を引き継ぐ ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.collection-hero__description a[href*="/collections/"], a[data-onddoka-keep-filters]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var current = new URLSearchParams(window.location.search);
    var keep = new URLSearchParams();
    current.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 || k === 'sort_by') keep.append(k, v);
    });
    var qs = keep.toString();
    track('category_link', (link.textContent || '').trim() + (qs ? ' +filters' : ''));
    if (!qs) return;
    e.preventDefault();
    var url = new URL(link.href, window.location.origin);
    keep.forEach(function (v, k) { url.searchParams.append(k, v); });
    window.location.href = url.toString();
  });

  /* ---------- SP のタイプ・カラーチップ（snippets/onddoka-quick-filters.liquid） ---------- */
  function syncQuickFilters() {
    var params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-onddoka-qf] [data-qf-param]').forEach(function (chip) {
      var on = params.getAll(chip.getAttribute('data-qf-param')).indexOf(chip.getAttribute('data-qf-value')) > -1;
      if (chip.getAttribute('aria-pressed') !== String(on)) chip.setAttribute('aria-pressed', String(on));
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-onddoka-qf] [data-qf-param]');
    if (!chip) return;
    var name = chip.getAttribute('data-qf-param');
    var value = chip.getAttribute('data-qf-value');
    var params = new URLSearchParams(window.location.search);
    var values = params.getAll(name);
    var i = values.indexOf(value);
    if (i > -1) values.splice(i, 1);
    else values.push(value);
    params.delete(name);
    values.forEach(function (v) { params.append(name, v); });
    params.delete('page');
    chip.setAttribute('aria-pressed', String(i === -1));
    track(name.indexOf('tag') > -1 ? 'qf_type_chip' : 'qf_color_chip', value + (i === -1 ? ' on' : ' off'));
    if (typeof FacetFiltersForm !== 'undefined' && document.getElementById('product-grid')) {
      FacetFiltersForm.renderPage(params.toString());
    } else {
      window.location.search = params.toString();
    }
  });

  window.addEventListener('popstate', function () {
    setTimeout(syncQuickFilters, 0);
  });

  /* ---------- SP：チップ列が見えなくなったら画面下に「絞り込みと並び替え」ボタンを出す ---------- */
  function activeFilterCount() {
    var n = 0;
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 && v !== '') n++;
    });
    return n;
  }

  function syncFloatCount() {
    var el = document.querySelector('[data-qf-float-count]');
    if (!el) return;
    var n = activeFilterCount();
    if (el.textContent !== String(n)) el.textContent = n;
    el.hidden = n === 0;
  }

  function initFloat() {
    var btn = document.querySelector('[data-qf-float]');
    var chips = document.querySelector('[data-onddoka-qf]');
    var grid = document.getElementById('ProductGridContainer');
    if (!btn || !chips || !grid || !('IntersectionObserver' in window)) return;

    var chipsVisible = true;
    var gridVisible = false;
    function update() {
      var drawer = document.querySelector('.mobile-facets__disclosure');
      var show = !chipsVisible && gridVisible && !(drawer && drawer.hasAttribute('open'));
      btn.classList.toggle('is-visible', show);
      btn.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === chips) chipsVisible = en.isIntersecting;
        else gridVisible = en.isIntersecting;
      });
      update();
    }).observe(chips);
    new IntersectionObserver(function (entries) {
      gridVisible = entries[0].isIntersecting;
      update();
    }, { rootMargin: '0px 0px -40% 0px' }).observe(grid);

    btn.addEventListener('click', function () {
      track('qf_float_open', activeFilterCount());
      var summary = document.querySelector('.mobile-facets__disclosure > summary');
      if (summary) summary.click();
      setTimeout(update, 50);
    });
    document.addEventListener('toggle', function (e) {
      if (e.target.classList && e.target.classList.contains('mobile-facets__disclosure')) update();
    }, true);
    syncFloatCount();
  }


  /* ---------- 絞り込みの適用を記録（どの経路でも URL の filter.* が変わる） ---------- */
  var lastFilterKey = null;
  function filterKey() {
    var parts = [];
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 && v !== '') parts.push(k.replace('filter.p.m.custom.', '').replace('filter.p.', '').replace('filter.v.', '') + '=' + v);
    });
    return parts.sort().join('&');
  }
  function checkFilterChange() {
    var k = filterKey();
    if (lastFilterKey === null) { lastFilterKey = k; return; }
    if (k !== lastFilterKey) {
      lastFilterKey = k;
      if (k) track('filter_apply', k);
    }
  }

  /* Dawn の絞り込みは history.pushState で URL を変える → そのタイミングで確実に検知（描画待ちに依存しない） */
  ['pushState', 'replaceState'].forEach(function (fn) {
    var orig = history[fn];
    if (typeof orig !== 'function') return;
    history[fn] = function () {
      var ret = orig.apply(this, arguments);
      setTimeout(checkFilterChange, 0);
      return ret;
    };
  });
  window.addEventListener('popstate', function () { setTimeout(checkFilterChange, 0); });

  /* 他のタブでの変更も反映 */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      syncButtons();
      renderPage();
    }
  });

  /* 絞り込み・並び替えで商品一覧が差し替わったら♡の状態を付け直す */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      syncButtons();
      syncQuickFilters();
      syncFloatCount();
      checkFilterChange();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- お気に入り一覧ページ ---------- */
  var page = null;
  var cache = {};

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'JPY';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'ja', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '¥' + Math.round(cents / 100).toLocaleString();
    }
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return undefined; });
    return cache[handle];
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function isOrderProduct(p) {
    return (p.tags || []).some(function (t) { return String(t).indexOf('order_') === 0; });
  }

  function addToCart(btn, variantId) {
    btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'cart-icon-bubble' }),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json && res.json.description);
        btn.textContent = page.dataset.tAdded + ' ✓';
        track('favpage_add_to_cart', variantId);
        btn.classList.add('is-done');
        var bubble = res.json.sections && res.json.sections['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (bubble && target) {
          var tmp = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section');
          if (tmp) target.innerHTML = tmp.innerHTML;
        }
        var view = btn.parentNode.querySelector('.onddoka-favcard__viewcart');
        if (view) view.hidden = false;
      })
      .catch(function (err) {
        btn.disabled = false;
        if (err && err.message) window.alert(err.message);
      });
  }

  function localUrl(url) {
    return root !== '/' && url.indexOf('/') === 0 ? root.replace(/\/$/, '') + url : url;
  }

  function buildCard(handle, p) {
    var t = page.dataset;
    p.url = localUrl(p.url);
    var li = el('li', 'onddoka-favcard');
    li.setAttribute('data-handle', handle);

    var media = el('a', 'onddoka-favcard__media');
    media.href = p.url;
    if (p.featured_image) {
      var img = el('img');
      img.src = imageUrl(p.featured_image, 600);
      img.srcset = [400, 600, 900].map(function (w) { return imageUrl(p.featured_image, w) + ' ' + w + 'w'; }).join(', ');
      img.sizes = '(min-width: 990px) 25vw, 50vw';
      img.alt = p.title;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    if (!p.available) media.appendChild(el('span', 'onddoka-favcard__soldout', t.tSoldOut));
    li.appendChild(media);

    var remove = el('button', 'onddoka-fav onddoka-fav--card is-active');
    remove.type = 'button';
    remove.setAttribute('aria-label', t.tRemove);
    remove.setAttribute('data-fav-remove', handle);
    remove.innerHTML = '<svg class="onddoka-fav__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.6-9.4-9.3C1.4 8 3.4 4.4 7 4.4c2 0 3.6 1.1 5 2.9 1.4-1.8 3-2.9 5-2.9 3.6 0 5.6 3.6 4.4 6.9-1.8 4.7-9.4 9.3-9.4 9.3z"/></svg>';
    li.appendChild(remove);

    var info = el('div', 'onddoka-favcard__info');
    var title = el('a', 'onddoka-favcard__title', p.title);
    title.href = p.url;
    info.appendChild(title);

    var price = el('p', 'onddoka-favcard__price');
    if (p.compare_at_price && p.compare_at_price > p.price) {
      price.appendChild(el('s', 'onddoka-favcard__compare', money(p.compare_at_price)));
      price.appendChild(document.createTextNode(' '));
      price.appendChild(el('span', 'onddoka-favcard__sale', money(p.price)));
    } else {
      price.textContent = p.price_varies ? money(p.price_min) + ' 〜' : money(p.price);
    }
    info.appendChild(price);

    var actions = el('div', 'onddoka-favcard__actions');
    var single = p.variants && p.variants.length === 1;
    if (p.available && single && !isOrderProduct(p)) {
      var add = el('button', 'button button--primary onddoka-favcard__add', t.tAddToCart);
      add.type = 'button';
      add.addEventListener('click', function () { addToCart(add, p.variants[0].id); });
      actions.appendChild(add);
      var viewCart = el('a', 'onddoka-favcard__viewcart link', t.tViewCart);
      viewCart.href = page.dataset.cartUrl;
      viewCart.hidden = true;
      actions.appendChild(viewCart);
    } else {
      var detail = el('a', 'button button--secondary onddoka-favcard__add', t.tViewDetail);
      detail.href = p.url;
      actions.appendChild(detail);
    }
    info.appendChild(actions);
    li.appendChild(info);
    return li;
  }

  function renderPage() {
    page = document.querySelector('[data-onddoka-fav-page]');
    if (!page) return;
    var grid = page.querySelector('[data-fav-grid]');
    var empty = page.querySelector('[data-fav-empty]');
    var clear = page.querySelector('[data-fav-clear]');
    var count = page.querySelector('[data-fav-page-count]');
    var list = read();

    /* ページタイトル：「All Items…」→「お気に入り｜猫の日用品店onddoka…」 */
    var heading = page.querySelector('.onddoka-favpage__title');
    var suffix = document.title.split('｜').slice(1).join('｜');
    if (heading && heading.firstChild) document.title = heading.firstChild.textContent.trim() + (suffix ? '｜' + suffix : '');

    count.textContent = list.length ? '（' + list.length + '）' : '';
    empty.hidden = list.length > 0;
    clear.hidden = list.length === 0;

    Promise.all(list.map(fetchProduct)).then(function (products) {
      grid.innerHTML = '';
      var missing = [];
      products.forEach(function (p, i) {
        if (p === null) missing.push(list[i]); /* 削除・非公開になった商品 */
        else if (p) grid.appendChild(buildCard(list[i], p));
      });
      if (missing.length) {
        write(read().filter(function (h) { return missing.indexOf(h) === -1; }));
        syncButtons();
        var n = read().length;
        count.textContent = n ? '（' + n + '）' : '';
        empty.hidden = n > 0;
        clear.hidden = n === 0;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-fav-remove]');
    if (rm && page) {
      var card = rm.closest('.onddoka-favcard');
      var t = card && card.querySelector('.onddoka-favcard__title');
      logFavorite(rm.getAttribute('data-fav-remove'), 'remove', 'favpage', t ? t.textContent : '');
      remove(rm.getAttribute('data-fav-remove'));
      syncButtons();
      renderPage();
      return;
    }
    var clear = e.target.closest('[data-fav-clear]');
    if (clear && page && window.confirm(page.dataset.tClearConfirm)) {
      read().forEach(function (h) { logFavorite(h, 'remove', 'favpage', ''); });
      write([]);
      syncButtons();
      renderPage();
    }
  });

  window.OnddokaFavorites = { read: read, has: has, toggle: toggle, remove: remove, sync: syncButtons };

  function init() {
    checkFilterChange();
    if (document.querySelector('[data-onddoka-fav-page]')) track('favpage_view', read().length);
    syncButtons();
    syncQuickFilters();
    initFloat();
    /* 選択中のチップが横スクロールの外に隠れないよう、最初の選択チップまで寄せる */
    document.querySelectorAll('[data-onddoka-qf] .onddoka-qf__scroll').forEach(function (row) {
      var on = row.querySelector('[aria-pressed="true"]');
      if (on) row.scrollLeft = Math.max(0, on.offsetLeft - row.offsetLeft - 8);
    });
    renderPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
